import type { ReactNode } from 'react'

import type { LANG, WithLoadingState } from '@eshop/type'

import css from './index.module.css'

import { Image } from '#/global/component/Image/Image'

import LinkTo from '#/global/helper/LinkTo'

interface Product {
    code: string
    detail: {
        image?: string
        slug: string
        title: string
        titleShort?: string
    }
    type: 'rental' | 'eshop'
}

interface Props {
    AddToCart: ReactNode
    lang: LANG
    onTitleClick?: () => void
    product: Product
}

export const ProductPreviewCompact = ({ AddToCart, loadingState, onTitleClick, product }: WithLoadingState<Props>) => {
    if (loadingState) {
        return (
            <div className={`r-product-preview-compact ${css.container}`}>
                <div className={`${css.img} loading`}>
                    <Image resolutionList={[{ width: 100, height: 100 }]} />
                </div>
                <div className={css.content}>
                    <div className={`${css.title} loading`} />
                    <div className="loading" />
                </div>
            </div>
        )
    }

    const href = LinkTo(`product-${product.type}`, product.code, product.detail.slug)

    return (
        <div className={`r-product-preview-compact ${css.container}`}>
            <div className={css.img}>
                <Image resolutionList={[{ width: 100, height: 100 }]} src={product.detail.image} />
            </div>
            <div className={css.content}>
                <a className={css.title} href={href} onClick={onTitleClick} rel="noreferrer" target="_blank">
                    {product.detail.titleShort ?? product.detail.title}
                </a>
                {AddToCart}
            </div>
        </div>
    )
}
